module.exports = __webpack_public_path__ + "static/media/refresh.7a08eced.svg";